interface BranchRef {
  id?: string | number | null
  name?: string | null
}

const normalizeName = (value: unknown): string =>
  value ? String(value).trim().toLowerCase() : ''

const toPositiveId = (value: unknown): number | null => {
  if (value === null || value === undefined || value === '') return null
  const id = Number(value)
  return !isNaN(id) && id > 0 ? id : null
}

/**
 * Whether an order belongs to the given branch. Matches by id when both sides
 * have one, otherwise by name (some order APIs return the branch as a name string only).
 */
export function isOrderFromBranch(
  order: { branch_id?: string | number | null; branchId?: string | number | null; branch?: unknown },
  branch: BranchRef
): boolean {
  const orderBranch = order.branch
  const orderBranchObj =
    orderBranch && typeof orderBranch === 'object' ? (orderBranch as BranchRef) : null

  const orderBranchId = toPositiveId(order.branch_id ?? order.branchId ?? orderBranchObj?.id)
  const currentBranchId = toPositiveId(branch.id)
  if (orderBranchId !== null && currentBranchId !== null) {
    return orderBranchId === currentBranchId
  }

  const orderBranchName = normalizeName(
    typeof orderBranch === 'string' ? orderBranch : orderBranchObj?.name
  )
  const currentBranchName = normalizeName(branch.name)
  return orderBranchName !== '' && orderBranchName === currentBranchName
}
